import { useState } from "react";
import { IoEye, IoEyeOff } from "react-icons/io5";

import * as S from "./styles";

interface Data {
  campanha: string;
}

interface Props {
  dataDadosUnidade: Data;
}

export default function Campanha(props: Readonly<Props>) {
  const [toggleEye, setToggleEye] = useState(false);

  return (
    <S.Container>
      <S.BodyContainer>
        <S.Row
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          {toggleEye ? (
            <S.TitleInfo>Campanha: </S.TitleInfo>
          ) : (
            <S.OverlayInfo style={{ width: "78.5px" }} />
          )}
          {toggleEye ? (
            <S.TitleInfo style={{ width: "450px" }}>
              {props?.dataDadosUnidade?.campanha}
            </S.TitleInfo>
          ) : (
            <S.OverlayInfo style={{ width: "76.5%" }} />
          )}
          <S.Rounded onClick={() => setToggleEye(!toggleEye)}>
            {toggleEye ? (
              <IoEye size={20} color="#2D5BFF" />
            ) : (
              <IoEyeOff size={20} color="#2D5BFF" />
            )}
          </S.Rounded>
        </S.Row>
      </S.BodyContainer>
    </S.Container>
  );
}
